module.exports = __webpack_public_path__ + "static/media/icon-facebook.9e83b4c0.webp";